// extracted by mini-css-extract-plugin
module.exports = {"listItem":"WorkspaceListItem_listItem__L5gs9"};